var domains = require('./domains.json');
var editions = require('./editions.json');
var editionConfigs = require('./configs.json');
var editionSettings = require('./settings.json');
var langs = require('./langs.json');
var hostPaths = require('./hostPaths.json');
var parseUri = require('./parseUri.js');

function buildURL(scheme, domain, path, query, fragment, shouldUndoSEO) {
	var location = this.window ? this.window.location : {
		protocol: 'http:',
		host: domains['espn']
	};

	if (arguments.length === 0) {
		domain = 'espn';
	}

	if (typeof scheme !== 'string') {
		scheme = location.protocol;
	}
	else if (/[^:]$/.test(scheme)) {
		scheme += ':';
	}

	if (scheme === 'https:' && (domain + '-secure') in domains) {
		domain = domain + '-secure';
	}

	var host = domains[domain];

	if (!path) {
		path = '';
	}
	else if (/^[^\/]/.test(path)) {
		path = '/' + path;
	}

	var queryString = '';
	if (typeof query === 'string') {
		queryString = query;
	}
	else if (query && typeof query === 'object') {
		queryString = Object.keys(query).map(function(k) {
			if ((shouldUndoSEO || k !== '_slug_') && query[k] != null) {
				return encodeURIComponent(k) + '=' + encodeURIComponent(query[k]);
			}
			else {
				return encodeURIComponent(query[k]);
			}
		}).join('&');
	}
	if (/^[^?]/.test(queryString)) {
		queryString = '?' + queryString;
	}

	if (typeof fragment !== 'string') {
		fragment = '';
	}
	else if (/^[^#]/.test(fragment)) {
		fragment = '#' + encodeURIComponent(fragment);
	}

	if ((queryString || fragment) && !path) {
		path = '/';
	}

	return scheme + '//' + host + path + queryString + fragment;
}


function underscorePathSEO(URL) {
	return URL.replace(/\/?\?/,'/_/').replace(/&|=/g,'/');
}


var domainEditionCache = {};
function getEditionByLocation(host, testHost) {
	if (!host) {
		if (this.window) {
			host = this.window.location.host;
		} else {
			host = testHost;
		}
	}
	if (domainEditionCache[host]) {
		return domainEditionCache[host];
	}
	for (var ed in editions) {
		var editionRE = new RegExp(editions[ed], 'i');
		if (editionRE.test(host)) {
			domainEditionCache[host] = ed;
			return ed;
		}
	}
}

function rewritePath(path, configs) {
	for (var i = 0; i < configs.length; i++) {
		var config = configs[i];

		langs.map(function(lang) {
			for (var root in config.roots[lang]) {
				var rootValue = config.roots[lang][root];

				var rootRE = new RegExp('^'+root, 'i');
				path = path.replace(rootRE, function(match, $1, offset, original){
					return rootValue;
				});
			}
			for (var seg in config.pathSegments[lang]) {
				var segment = config.pathSegments[lang][seg];

				var segRE = new RegExp('/'+seg+'(/|$)', 'i');
				path = path.replace(segRE, function(match, $1, offset, original){
					return '/'+segment+$1;
				});
			}
		});
	}
	return path;
}

function rewriteQuery(query, configs) {
	for (var i = 0; i < configs.length; i++) {
		var config = configs[i];
		langs.map(function(lang) {
			var newQuery = {};
			for (var key in query) {
				key = decodeURIComponent(key);
				if (query.hasOwnProperty(key)) {
					var newKey = config.paramKeys[lang][key] || key,
						oldVal = query[key]==null ? null : decodeURIComponent(query[key]),
						newValue = config.paramValues[lang][oldVal] || oldVal;

					newQuery[newKey] = newValue;
				}
			}
			query = newQuery;
		});
	}
	return query;
}

function overrideUrl(url, configs) {
	for (var i = 0; i < configs.length; i++) {
		var config = configs[i];

		langs.map(function(lang) {
			for (var u in config.urls[lang]) {
				var urlValue = config.urls[lang][u];
				url = url.replace(u, urlValue);
			}
		});
	}

	url = url.replace(/%2C/g, ','); // commas cause issues in the Android app (as of 2017-01-06)

	return url;
}

function rewriteUrl(url, editionOverride, options) {
	var parsed = parseUri(url),
		edition = getEditionByLocation.call(this, editionOverride, parsed.host),
		path = parsed.path,
		query = parsed.queryKey,
		hash = parsed.anchor,
		splitIndex = path.indexOf('/_/'),
		configs = [],
		config = editionConfigs[edition],
		rewrites,
		seo = true,
		shouldUndoSEO = false;


	if (!edition) {
		return url;
	}
	if (config !== undefined) {
		rewrites = config.rewrites;
	}
	var urlEdition = getEditionByLocation(parsed.host || editionOverride);
	if(!urlEdition){
		return url;
	}
	var urlConfig = editionConfigs[urlEdition];
	if (urlConfig && urlConfig.seo !== undefined) {
		seo = urlConfig.seo;
	}

	if ((config && config.notActuallyAnEdition) || (urlConfig && urlConfig.notActuallyAnEdition)) {
		//no rewrites if either is not an edition
		rewrites = undefined;
		
		var baseEdition = urlEdition.replace(/-(go|qa)$/, '');
		if (/-qa$/.test(edition) && editionConfigs[baseEdition+'-qa']) {
			edition = baseEdition+'-qa';
		} else if (/-go$/.test(edition) && editionConfigs[baseEdition+'-go']) {
			edition = baseEdition+'-go';
		} else {
			edition = baseEdition;
		}
	}

	if (splitIndex > -1) {
		var queryString = path.substring(splitIndex + 3);
		path = path.substring(0, splitIndex);

		var parts = queryString.split('/');
		while (parts.length > 1) {
			query[parts.shift()] = parts.shift();
		}
		if (parts.length == 1) {
			query['_slug_'] = parts.shift();
		}
	}

	if (rewrites !== undefined) {
		query = rewriteQuery(query, configs);
		for (var ed in rewrites) {
			if (rewrites.hasOwnProperty(ed)) {
				var config = editionSettings[rewrites[ed]];
				if (config !== undefined) {
					configs.push(config);
				}
			}
		}

		for(var host in hostPaths){
			if (hostPaths.hasOwnProperty(host)) {
				if(parsed.host.match(new RegExp(host, 'i')) &&
					!path.match(new RegExp("^"+hostPaths[host]), 'i')){
					path = hostPaths[host]+path;
					break;
				}
			}
		}

		path = rewritePath(path, configs);
		query = rewriteQuery(query, configs);
	}

	if (hash) {
		hash = '#'+hash;
	}

	if(options && typeof options==='object'){
		if(typeof options.seo==='boolean'){
			seo = options.seo;

			if(options.seo===false){
				shouldUndoSEO = true;
			}
		}
	}

	var result = buildURL(parsed.protocol, edition, path, query, hash, shouldUndoSEO);

	if (seo) {
		result = underscorePathSEO(result);
	}
	else if(shouldUndoSEO){
		result = undoSEO(result);
	}

	return overrideUrl(result, configs);
}

function undoSEO(url){
	/**
	 * convert request from SEO to normal query string format
	 *
	 * SEO: http://www.espn.com/espn/story/_/id/23403800/mariano-rivera-misty-treanor-herschel-walker-designated-chair-president-council-sports-fitness-nutrition
	 * query string: http://www.espn.com/espn/story?id=23403800&_slug_=mariano-rivera-misty-treanor-herschel-walker-designated-chair-president-council-sports-fitness-nutrition
	 *
	 * @param  {String} Request url like above example
	 * @return {String} query string format of url
	 */

	var result    = url,
		ampersand = '',
		query, parts;

	if(typeof url === 'string' && url.length>0){
		parts = url.split('/_/');

		if (parts.length > 1) {
			result = parts[0]+'?'; //part before query string

			query = parts[1].split('/');

			while (query.length > 1) {
				result+=ampersand+query.shift()+'='+query.shift();
				ampersand='&'
			}

			if (query.length == 1) {
				result+=ampersand+'_slug_='+query.shift().replace('?', '&');
			}
		}
	}

	return result;
}

module.exports = function espnURL(rewriteURL, options) {
	if (typeof rewriteURL !== 'string') {
		rewriteURL = 'http://www.espn.com';
	}
	if(options && typeof options==='object'){
		var editionOverride = options && options.editionOverride;
		return rewriteUrl(rewriteURL, editionOverride, options);
	}
	return rewriteUrl(rewriteURL, options);
};



//////////////////
// WEBPACK FOOTER
// ../~/espn-url/espnURL.js
// module id = 821
// module chunks = 0